import { render, staticRenderFns } from "./SelectionChangeWarning.vue?vue&type=template&id=295c25d6&"
import script from "./SelectionChangeWarning.vue?vue&type=script&lang=js&"
export * from "./SelectionChangeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports